import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
import type { Testimonial } from './salesData';
interface TestimonialsSectionProps {
  title: string;
  items: Testimonial[];
  variant?: 'blush' | 'cream';
}
export function TestimonialsSection({
  title,
  items,
  variant = 'cream'
}: TestimonialsSectionProps) {
  const bg = variant === 'blush' ? 'bg-blush' : 'bg-cream';
  return <section className={`${bg} py-16 sm:py-24`} data-id="element-250" data-mp="1d134p6m13kfb">
      <div className="mx-auto max-w-6xl px-5" data-id="element-251" data-mp="1i0xv791w67zu">
        <h2 className="text-center font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-252" data-mp="1i1qqndvehb2o">{title}</h2>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-253" data-mp="142hlracna3e0">
          {items.map((t, i) => <motion.div key={`${t.initials}-${i}`} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} data-id="element-254" data-mp="1839vs5tcccbc" data-mpi={i}>
              <TestimonialCard t={t} data-id="element-255" data-mp="2uzzw2v9bakwb" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}